module.exports = __webpack_public_path__ + "static/media/check_sante_securite.6cdf759d.png";